// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1qNzc","header":"MessagesList_header__n7rue","chat":"MessagesList_chat__1vkOa"};